<template>
  <div class="form-group text-left">
    <label for="field">{{ label }}</label>
    <textarea class="form-control" :disabled="disabled" :id="field" rows="3" v-model="text"
              @change="update"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: 'EvaluationTextBox',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  methods: {
    update() {
      this.$emit('update-value', { field: this.field, value: this.text });
    },
  },
};
</script>

<style scoped>

</style>
